import { API_CONFIG, apiUtils } from '../config';

const examApi = {
  getAllExams: async (filters = {}) => {
    // Support both single unitId and multiple unitIds
    // Backend expects: unitIds=["id1","id2"] or unitId=id
    const params = new URLSearchParams();
    
    if (filters.unitIds && Array.isArray(filters.unitIds) && filters.unitIds.length > 0) {
      params.append('unitIds', JSON.stringify(filters.unitIds));
    } else if (filters.unitId) {
      params.append('unitId', filters.unitId);
    }
    
    if (filters.examType) {
      params.append('examType', filters.examType);
    }
    
    if (filters.page) {
      params.append('page', filters.page);
    }
    
    if (filters.limit) {
      params.append('limit', filters.limit);
    }
    
    if (filters.status) {
      params.append('status', filters.status);
    }
    
    if (filters.academicYear) {
      params.append('academicYear', filters.academicYear);
    }
    
    const url = `${API_CONFIG.BASE_URL}/exam${params.toString() ? '?' + params.toString() : ''}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  getExamById: async (examId) => {
    const url = `${API_CONFIG.BASE_URL}/exam/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  createExam: async (examData) => {
    const url = `${API_CONFIG.BASE_URL}/exam`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(examData),
    });
  },

  updateExam: async (examId, examData) => {
    const url = `${API_CONFIG.BASE_URL}/exam/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'PUT',
      body: JSON.stringify(examData),
    });
  },

  deleteExam: async (examId) => {
    const url = `${API_CONFIG.BASE_URL}/exam/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'DELETE',
    });
  },
  
  getExamResults: async (examId, filters = {}) => {
      const queryParams = apiUtils.buildQueryString(filters);
      const url = `${API_CONFIG.BASE_URL}/exam/${examId}/results?${queryParams}`;
      return apiUtils.makeAuthenticatedRequest(url);
  },
  
  saveExamResults: async (examId, resultsData) => {
      const url = `${API_CONFIG.BASE_URL}/exam/${examId}/results`;
      return apiUtils.makeAuthenticatedRequest(url, {
          method: 'POST',
          body: JSON.stringify(resultsData)
      });
  },

  generateAdmitCards: async (examId, filters = {}) => {
    const queryParams = apiUtils.buildQueryString(filters);
    const url = `${API_CONFIG.BASE_URL}/exam/admit-cards/${examId}?${queryParams}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  getDetailedExamStats: async (examId) => {
    const url = `${API_CONFIG.BASE_URL}/exam/detailed-stats/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  sendSchedule: async (examId, targetAudience = 'both') => {
    const url = `${API_CONFIG.BASE_URL}/exam/send-schedule/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({ targetAudience })
    });
  },

  exportExamResults: async (ids, format) => {
    const url = `${API_CONFIG.BASE_URL}/exam/export?ids=${ids}&format=${format}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Create exam notice with dynamic template and params
  createExamNotice: async (examId, noticeData = {}) => {
    const url = `${API_CONFIG.BASE_URL}/exam/create-notice/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(noticeData)
    });
  },

  // Get exam statistics
  getExamStatistics: async (examId) => {
    const url = `${API_CONFIG.BASE_URL}/exam/stats/${examId}`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Send upcoming exam reminders via WhatsApp
  sendUpcomingExamReminders: async (academicYear, phoneNumberId) => {
    const params = academicYear ? `?academicYear=${academicYear}` : '';
    const url = `${API_CONFIG.BASE_URL}/exam/whatsapp/upcoming${params}`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({ phoneNumberId }),
    });
  },

  // Result Notification
  sendResultNotification: async (payload) => {
    const url = `${API_CONFIG.BASE_URL}/result-notifications/send`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(payload)
    });
  }
};

export default examApi;
